import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from './constants.service';

@Injectable({
	providedIn: 'root'
})
export class GroupIHomeService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }

	getHomePieChartData(periodId: string): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/homePieChart/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(catchError(this.handleError));

	}

	getHomeTiersData(periodId: string): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/homeGrid/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(catchError(this.handleError));
	}

	getTilesValue(periodId: string): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/homeTiles/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(catchError(this.handleError));
	}

	getbarChartValue(periodId: string): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/homeBarGraph/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(catchError(this.handleError));
	}

	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}